import { AxiosResponse } from 'axios'
import Cookies from 'js-cookie'
import { webApi } from 'src/services/api/config'

/**
 * Gets all users with an active contract
 * @returns list of users
 */
export const getUsers = async (): Promise<AxiosResponse> => {
  return await webApi.get('/api/Users', {
    headers: {
      'Content-type': 'application/json',
      Authorization:
        'bearer ' + (Cookies.get('auth-token') ? Cookies.get('auth-token') : '')
    }
  })
}
